
(function () {
  document.body.classList.add('mx');
  var b = document.getElementById('mx-burger'), m = document.getElementById('mx-mnav');
  if (b && m) {
    b.addEventListener('click', function () { var o = m.classList.toggle('is-open'); b.setAttribute('aria-expanded', o); });
    m.addEventListener('click', function (e) { if (e.target.closest('a')) { m.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); } });
  }
  var pr = document.getElementById('mx-prose'), toc = document.getElementById('mx-toc');
  if (pr && toc) {
    var hs = pr.querySelectorAll('h2'), ol = toc.querySelector('ol');
    hs.forEach(function (h, i) { if (!h.id) h.id = 'r' + (i + 1); var li = document.createElement('li'), a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li); });
    if (hs.length > 2) toc.hidden = false;
  }
  var f = document.getElementById('mx-form');
  if (f && !f.action.match(/contact/)) f.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!f.checkValidity()) { f.reportValidity(); return; }
    document.getElementById('mx-ok').hidden = false;
  });
})();
